import {createSubmitRequestTypes} from "./helpers";

export const REQUEST_CREATE_PURCHASE_ORDER = "PURCHASE_ORDER:REQUEST_CREATE_PURCHASE_ORDER";
export const CREATE_PURCHASE_ORDER = createSubmitRequestTypes("PURCHASE_ORDER:CREATE_PURCHASE_ORDER");
export const requestCreatePurchaseOrder = () => ({ type: REQUEST_CREATE_PURCHASE_ORDER });
export const cancelCreatePurchaseOrder = () => ({ type: CREATE_PURCHASE_ORDER.CANCEL });
export const successCreatePurchaseOrder = () => ({ type: CREATE_PURCHASE_ORDER.SUCCESS });

export const REQUEST_EDIT_PURCHASE_ORDER = "PURCHASE_ORDER:REQUEST_EDIT_PURCHASE_ORDER";
export const EDIT_PURCHASE_ORDER = createSubmitRequestTypes("PURCHASE_ORDER:EDIT_PURCHASE_ORDER");
export const requestEditPurchaseOrder = (purchaseOrderId) => ({ type: REQUEST_EDIT_PURCHASE_ORDER, purchaseOrderId });
export const cancelEditPurchaseOrder = () => ({ type: EDIT_PURCHASE_ORDER.CANCEL });
export const successEditPurchaseOrder = () => ({ type: EDIT_PURCHASE_ORDER.SUCCESS });

export const REQUEST_EDIT_PURCHASE_ORDER_LINES = "PURCHASE_ORDER:REQUEST_EDIT_PURCHASE_ORDER_LINES";
export const EDIT_PURCHASE_ORDER_LINES = createSubmitRequestTypes("PURCHASE_ORDER:EDIT_PURCHASE_ORDER_LINES");
export const requestEditPurchaseOrderLines = (purchaseOrderId) => ({ type: REQUEST_EDIT_PURCHASE_ORDER_LINES, purchaseOrderId });
export const cancelEditPurchaseOrderLines = () => ({ type: EDIT_PURCHASE_ORDER_LINES.CANCEL });
export const successEditPurchaseOrderLines = () => ({ type: EDIT_PURCHASE_ORDER_LINES.SUCCESS });

export const REQUEST_PLACE_PURCHASE_ORDER = "PURCHASE_ORDER:REQUEST_PLACE_PURCHASE_ORDER";
export const PLACE_PURCHASE_ORDER = createSubmitRequestTypes("PURCHASE_ORDER:PLACE_PURCHASE_ORDER");
export const requestPlacePurchaseOrder = (purchaseOrderId) => ({ type: REQUEST_PLACE_PURCHASE_ORDER, purchaseOrderId });
export const cancelPlacePurchaseOrder = () => ({ type: PLACE_PURCHASE_ORDER.CANCEL });
export const successPlacePurchaseOrder = () => ({ type: PLACE_PURCHASE_ORDER.SUCCESS });

export const REQUEST_RECEIVE_PURCHASE_ORDER = "PURCHASE_ORDER:REQUEST_RECEIVE_PURCHASE_ORDER";
export const RECEIVE_PURCHASE_ORDER = createSubmitRequestTypes("PURCHASE_ORDER:RECEIVE_PURCHASE_ORDER");
export const requestReceivePurchaseOrder = (purchaseOrderId) => ({ type: REQUEST_RECEIVE_PURCHASE_ORDER, purchaseOrderId });
export const cancelReceivePurchaseOrder = () => ({ type: RECEIVE_PURCHASE_ORDER.CANCEL });
export const successReceivePurchaseOrder = () => ({ type: RECEIVE_PURCHASE_ORDER.SUCCESS });

export const REQUEST_CANCEL_PURCHASE_ORDER = "PURCHASE_ORDER:REQUEST_CANCEL_PURCHASE_ORDER";
export const CANCEL_PURCHASE_ORDER = createSubmitRequestTypes("PURCHASE_ORDER:CANCEL_PURCHASE_ORDER");
export const requestCancelPurchaseOrder = (purchaseOrderId) => ({ type: REQUEST_CANCEL_PURCHASE_ORDER, purchaseOrderId });
export const cancelCancelPurchaseOrder = () => ({ type: CANCEL_PURCHASE_ORDER.CANCEL });
export const successCancelPurchaseOrder = () => ({ type: CANCEL_PURCHASE_ORDER.SUCCESS });
